/* eslint-disable import/prefer-default-export */

export const URL_CONFIG = {
  AFTER_LOGOUT_RETURN_TO: window.location.origin,
};
